import { GenericDataDisplayGroupedItemsRecursive } from "react-migration/domains/map/components/GenericDataDisplayGroupedItemsRecursive";
import { Hatch } from "react-migration/domains/constraints/components/Hatch/Hatch";
import {
  LayerTypeSelectionDetailViewProps,
  LayerTypeSelectionHeaderProps,
  SelectionHandler,
} from "react-migration/layouts/map/Multilayer/types";
import { GENERIC_GEOJSON_COLOUR_SYMBOL, GENERIC_GEOJSON_TITLE_SYMBOL } from "./constants";

export const GenericGeoJsonFeatureSelectionHandler: SelectionHandler = {
  SelectionHeader: GenericGeoJsonFeatureSelectionHeader,
  SelectionDetailView: GenericGeoJsonFeatureSelectionDetailView,
};

function GenericGeoJsonFeatureSelectionHeader({ selection }: LayerTypeSelectionHeaderProps) {
  const {
    [GENERIC_GEOJSON_COLOUR_SYMBOL as unknown as string]: colour,
    [GENERIC_GEOJSON_TITLE_SYMBOL as unknown as string]: title,
  } = selection.feature?.properties || {};

  return (
    <div className="p-2 pb-1 flex flex-row gap-2">
      {colour && <Hatch fillColor={colour} />}
      <span className="font-semibold">{title}</span>
    </div>
  );
}

function GenericGeoJsonFeatureSelectionDetailView({ selection }: LayerTypeSelectionDetailViewProps) {
  return (
    <div className="m-2 mt-0 text-xs p-2 overflow-auto">
      <GenericDataDisplayGroupedItemsRecursive
        data={selection.feature?.properties || undefined}
        labelTranslationNamespace="generic_geojson_feature_selection_handler.selection_detail_view.label"
        hideEmptyValues
      />
    </div>
  );
}
